var map = {
	"./2048Stack/1.png": 49,
	"./2048Stack/2.png": 50,
	"./2048Stack/2048_Stack.gif": 51,
	"./2048Stack/icon.png": 52,
	"./ballCrunch/1.png": 53,
	"./ballCrunch/2.png": 54,
	"./ballCrunch/ball_crunch.gif": 55,
	"./ballCrunch/icon.png": 56,
	"./ballFlow/1.jpg": 57,
	"./ballFlow/2.jpg": 58,
	"./ballFlow/ball_flow.gif": 59,
	"./ballFlow/icon.png": 60,
	"./bulletRun/1.png": 61,
	"./bulletRun/2.png": 62,
	"./bulletRun/bulletRun.gif": 63,
	"./bulletRun/icon.png": 64,
	"./colorDown/1.png": 65,
	"./colorDown/2.png": 66,
	"./colorDown/Color_Down.gif": 67,
	"./colorDown/icon.png": 68,
	"./colorVsWhite/color.gif": 69,
	"./colorVsWhite/color.png": 70,
	"./colorVsWhite/color2.png": 71,
	"./colorVsWhite/color_icon.png": 72,
	"./crowdRush/1.png": 73,
	"./crowdRush/2.png": 74,
	"./crowdRush/crowd_rush.gif": 75,
	"./crowdRush/icon.png": 76,
	"./crushColor/1.png": 77,
	"./crushColor/2.png": 78,
	"./crushColor/Crush_Color.gif": 79,
	"./crushColor/icon.png": 80,
	"./dice_duel/1.png": 81,
	"./dice_duel/2.png": 82,
	"./dice_duel/dice_duel.gif": 83,
	"./dice_duel/icon.png": 84,
	"./drawClean/draw_clean.gif": 85,
	"./drawClean/draw_clean.png": 86,
	"./drawClean/draw_clean2.png": 87,
	"./drawClean/draw_icon.png": 88,
	"./dunkLow/dunk_low.gif": 89,
	"./dunkLow/dunk_low.png": 90,
	"./dunkLow/dunk_low2.png": 91,
	"./dunkLow/dunk_low_icon.png": 92,
	"./eggFarm/egg_farm.gif": 93,
	"./eggFarm/egg_farm.png": 94,
	"./eggFarm/egg_farm2.png": 95,
	"./eggFarm/egg_farm_icon.png": 96,
	"./fireLine/fireLine.gif": 97,
	"./fireLine/fireLine.jpg": 98,
	"./fireLine/fireLine2.jpg": 99,
	"./fireLine/fireLine_icon.png": 100,
	"./funDelivery/1.png": 101,
	"./funDelivery/2.png": 102,
	"./funDelivery/funDelivery.gif": 103,
	"./funDelivery/icon.png": 104,
	"./glassBalls/1.png": 105,
	"./glassBalls/2.png": 106,
	"./glassBalls/glass_balls.gif": 107,
	"./glassBalls/icon.png": 108,
	"./halfCut/halfCut.gif": 109,
	"./halfCut/halfCut.jpg": 110,
	"./halfCut/halfCut2.jpg": 111,
	"./halfCut/halfCut_icon.png": 112,
	"./headFit/1.png": 113,
	"./headFit/2.png": 114,
	"./headFit/head_fit.gif": 115,
	"./headFit/icon.png": 116,
	"./juicyCut3d/1.png": 117,
	"./juicyCut3d/2.png": 118,
	"./juicyCut3d/icon.png": 119,
	"./juicyCut3d/juicyCut.gif": 120,
	"./knifeDrop/1.png": 121,
	"./knifeDrop/2.png": 122,
	"./knifeDrop/icon.png": 123,
	"./knifeDrop/knife_drop.gif": 124,
	"./linkmo/1.png": 125,
	"./linkmo/2.png": 126,
	"./linkmo/icon.png": 127,
	"./linkmo/linkmo.gif": 128,
	"./loveMaze/1.png": 129,
	"./loveMaze/2.png": 130,
	"./loveMaze/icon.png": 131,
	"./loveMaze/love_maze.gif": 132,
	"./lumberjack/1.png": 133,
	"./lumberjack/2.png": 134,
	"./lumberjack/icon.png": 135,
	"./lumberjack/lumberjack.gif": 136,
	"./matches/1.png": 137,
	"./matches/2.png": 138,
	"./matches/icon.png": 139,
	"./matches/matches.gif": 140,
	"./numberBlocks/numberBlocks.gif": 141,
	"./numberBlocks/numberBlocks.png": 142,
	"./numberBlocks/numberBlocks2.png": 143,
	"./numberBlocks/numberBlocks_icon.png": 144,
	"./partyPooper/1.png": 145,
	"./partyPooper/2.png": 146,
	"./partyPooper/icon.png": 147,
	"./partyPooper/party_pooper.gif": 148,
	"./ringBuzz/1.png": 149,
	"./ringBuzz/2.png": 150,
	"./ringBuzz/Ring_Buzz.gif": 151,
	"./ringBuzz/icon.png": 152,
	"./rope_pull/1.png": 153,
	"./rope_pull/2.png": 154,
	"./rope_pull/icon.png": 155,
	"./rope_pull/rope_pull.gif": 156,
	"./safariRun/1.jpg": 157,
	"./safariRun/2.jpg": 158,
	"./safariRun/icon.png": 159,
	"./safariRun/safari_run.gif": 160,
	"./shapesFit/1.png": 161,
	"./shapesFit/2.png": 162,
	"./shapesFit/icon.png": 163,
	"./shapesFit/shapes_fit.gif": 164,
	"./sticked3d/1.jpg": 165,
	"./sticked3d/2.jpg": 166,
	"./sticked3d/icon.png": 167,
	"./sticked3d/sticked.gif": 168,
	"./upWay/1.png": 169,
	"./upWay/2.png": 170,
	"./upWay/icon.png": 171,
	"./upWay/up_way.gif": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;